"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.is2DTool = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function is2DTool(type) {
    return (type === bridge_schema_1.ToolType.StickyText ||
        type === bridge_schema_1.ToolType.StickyHandWriting ||
        type === bridge_schema_1.ToolType.Labels ||
        type === bridge_schema_1.ToolType.Pen);
}
exports.is2DTool = is2DTool;
